import { combineReducers } from 'redux';
import reservation from './reservation';
import application from './application';

const meetgo = combineReducers({
	reservation,
	application,
});

export default meetgo;
